import React from 'react';
import { ProductJourney } from '../../../../../Components/DPP/Controls/ProductJourney';
import { Heading, URLLink, DigitalAsset, Source, TestingControl } from './index';
import { Google } from '../../../../../Components/DPP/Controls/Google';
import { Html } from '../../../../../Components/DPP/Controls/Html';
import { Spacer } from '../../../../../Components/DPP/Controls/Spacer';
import { ProductImpact } from '../../../../../Components/DPP/Controls/ProductImpact';
import { Navigation } from '../../../../../Components/DPP/Controls/Navigation';
import { CustomSection } from '../../../../../Components/DPP/Controls/CustomSection';
import { RightsAccess } from '../../../../../Components/helper';
import { CareUserLabelInstruction } from '../../../../../Components/DPP/Controls/CareUserLabelInstruction';

import { useDPPState } from '../../Context/index';
import CompanyStamp from '../../../../../Components/DPP/Controls/CompanyStamp';

function ElementTemplateDPP(props) {
  const { TestingRight } = RightsAccess();
  const { dppState, setDppState } = useDPPState();

  const { dataIndex, dppEle, onClick, hideCustomSection, handleChildDrop, editingCustomInput, deleteCustomSectionItem, libraryBasicData } = props;
  const mainFunction = () => {
    switch (props?.keys) {
      case 'heading':
        return <Heading {...props} {...dppEle} />;
      case 'company_stamp':
        return <CompanyStamp {...props} {...dppEle} />;
      case 'url_link':
        return <URLLink {...props} {...dppEle} />;
      case 'digital_asset':
        return <DigitalAsset {...props} {...dppEle} />;
      case 'source':
        return <Source {...props} {...dppEle} />;
      case 'product_journey':
        return (
          <ProductJourney
            {...props}
            {...dppEle}
            navigateId={dppState?.navigateId}
            setDppState={setDppState}
            sectionId="product-journey-id"
            expColl={dppState}
            libraryBasicData={libraryBasicData}
            fromProduct={false}
          />
        );
      case 'testing_control':
        return TestingRight ? <TestingControl {...props} {...dppEle} /> : null;
      case 'google':
        return <Google {...props} {...dppEle} />;
      case 'html':
        return <Html {...props} {...dppEle} />;
      case 'product_impact':
        return (
          <ProductImpact {...props} {...dppEle} navigateId={dppState?.navigateId} setDppState={setDppState} sectionId="product-impact-id" expColl={dppState} />
        );
      case 'navigation':
        return <Navigation {...props} {...dppEle} onClick={onClick} />;
      case 'spacer':
        return <Spacer {...props} {...dppEle} onClick={onClick} />;
      case 'custom_section':
        return hideCustomSection ? null : (
          <CustomSection
            {...props}
            {...dppEle}
            onClick={onClick}
            handleChildDrop={handleChildDrop}
            parentIndex={dataIndex}
            editingCustomInput={editingCustomInput}
            navigateId={dppState?.navigateId}
            setDppState={setDppState}
            deleteCustomSectionItem={deleteCustomSectionItem}
            sectionId={dppEle?.uniqueId ? `finer-details-id-${dppEle?.uniqueId}` : 'finer-details-id'}
          />
        );
      case 'care_user_instruction':
        return (
          <CareUserLabelInstruction
            {...props}
            {...dppEle}
            navigateId={dppState?.navigateId}
            setDppState={setDppState}
            onClick={onClick}
            sectionId="care-user-instructions-id"
            expColl={dppState}
          />
        );
      default:
        return <div className="height-150" />;
    }
  };
  return <div key={dataIndex}>{mainFunction()}</div>;
}

export default React.memo(ElementTemplateDPP);
